import { render, staticRenderFns } from "./docLinkDescr.vue?vue&type=template&id=3733c280&scoped=true"
import script from "./docLinkDescr.vue?vue&type=script&lang=js"
export * from "./docLinkDescr.vue?vue&type=script&lang=js"
import style0 from "./docLinkDescr.vue?vue&type=style&index=0&id=3733c280&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3733c280",
  null
  
)

export default component.exports